import { FlyerPage } from '../types';

export const calculateCompletionPercentage = (pages: FlyerPage[]): number => {
  if (!pages || pages.length === 0) return 0;

  let totalSlots = 0;
  let filledSlots = 0;

  pages.forEach((page) => {
    // Each page always has 8 slots
    totalSlots += 8;
    filledSlots += page.slots.filter((slot) => slot && slot.type !== 'empty').length;
  });

  return totalSlots > 0 ? Math.round((filledSlots / totalSlots) * 100) : 0;
};

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('cs-CZ', {
    style: 'currency',
    currency: 'CZK',
  }).format(amount);
};

export const formatDate = (date: string | Date): string => {
  return new Intl.DateTimeFormat('cs-CZ').format(new Date(date));
};

export const formatDateTime = (date: string | Date): string => {
  return new Intl.DateTimeFormat('cs-CZ', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(date));
};

export const isValidEAN = (ean: string): boolean => {
  return /^\d{8,13}$/.test(ean);
};

export const cn = (...classes: (string | boolean | undefined)[]): string => {
  return classes.filter(Boolean).join(' ');
};

// Bezpečný název PDF souboru z názvu letáku: odstraní znaky nepovolené v názvech
// souborů (Windows/obecně) < > : " / \ | ? *, řídicí znaky a koncové tečky/mezery.
// Fallback na zadanou náhradu (typicky id letáku), když by výsledek byl prázdný.
export const sanitizePdfFilename = (name?: string, fallback = 'letak'): string => {
  const base = (name ?? '')
    // eslint-disable-next-line no-control-regex
    .replace(/[<>:"/\\|?*\x00-\x1F]/g, '')
    .replace(/[.\s]+$/, '')
    .trim();
  return `${base || fallback}.pdf`;
};

export const getProductImageUrl = (productId: string, version?: string): string => {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
  const base = `${API_URL}/products/${productId}/image`;
  // The image endpoint sends a 1-year immutable cache on a URL that never changes,
  // so a replaced image would keep showing the stale cached copy. Append the product's
  // updatedAt as a version so the URL changes whenever the product (and its image) does.
  return version ? `${base}?v=${encodeURIComponent(version)}` : base;
};

export const getIconImageUrl = (iconId: string): string => {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
  return `${API_URL}/products/icons/${iconId}/image`;
};

export const getBrandLogoUrl = (brandId: string, version?: string): string => {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
  // Must respect REACT_APP_API_URL - production serves via the IIS proxy, not localhost:4000.
  const base = `${API_URL}/brands/${brandId}/logo`;
  return version ? `${base}?v=${encodeURIComponent(version)}` : base;
};
